import { AppData } from './types';

export default class AppConfig implements AppData {
  cardCount: number;
  cardNodes: number[];
  topics: number[];
  sectionTitle: string;
  excludeNews: boolean;
  initialApi: string;
  loadApi: string;
  excludeNode: number;
  
  constructor(
    cardCount: number | null,
    cardNodes: number[],
    topics: number[],
    st: string | null,
    noNews: boolean | null,
    initialApi: string,
    loadApi: string ,
    excludeNode: number | null
   
  ) {    
    //cardcount must be multiples of 3
    this.cardCount = cardCount && cardCount !== 0 && cardCount % 3 == 0 ? cardCount : 3;
    this.cardNodes = cardNodes;
    this.topics = topics;
    this.sectionTitle = st && st != '' ? st : 'Related Content';
    this.excludeNews = noNews && noNews != null ? noNews : false; 
    this.initialApi = initialApi ? initialApi : '';
    this.loadApi = loadApi? loadApi : '';
    this.excludeNode = excludeNode ? excludeNode : 0;

  }
}
